// extracted by mini-css-extract-plugin
module.exports = {"operation":"Operation_style_operation__u2Kvj","item":"Operation_style_item__2eolp","plus":"Operation_style_plus__2N4H7","today":"Operation_style_today__vVlJs"};